var storage = {};

export default {
    pageSize   : 15,
    
    showMyDialog: false,
    mediaviewer: '',

    getRelated: function () {      
      return {
              "Starren" : [{cd:"1",va:"1 Star"},{cd:"2",va:"3 Star"},{cd:"3",va:"3 Star"},{cd:"4",va:"4 Star"},{cd:"5",va:"5 Star"}],
              "status"  : [{cd:"1",va:"Yes"},{cd:"0",va:"No"}],
              "active"  : [{cd:"1",va:"Active"},{cd:"0",va:"Not Active"}],
             } 
    },

    getValue: function (name) {
      return storage[name];
    },

    setValue: function (name,value) {
      storage[name] = value;
    },

    // Default messages (single lingual....) 

    confirmed: "Confirmed",
    savedone: "Done",

    getText(textid,var1,var2,var3) {
      var txt;
      if (textid == 100)
        txt = "Zeker weten om {1} '{2}' te verwijderen ?";
      else if (textid == 101)
        txt= "Verwijder {1}";
      else if (textid == 102)
        txt = "De {1} met omschrijving {2} is verwijderd.";

      else if (textid == 110)
        txt = "Wijzig {1} {2}";
      else if (textid == 111)
        txt = "Toevoegen {1}";
      
      else if (textid == 120) 
        txt = "Deze {1} is toevoegd";
      else if (textid == 121) 
        txt = "Deze {1} is gewijzigd!";     

      return txt.replace("{1}",var1).replace("{2}",var2).replace("{3}",var3);
    }
    


}



// WEBPACK FOOTER //
// ./src/common/AppSettings.js